module.exports = __webpack_public_path__ + "img/7.9559c291.png";